import React, { FC, useState } from 'react'
import { IProps } from './types'

import './styles.scss'
import { convertHourToLocalTime } from './../../utils/general'

export const Range: FC<IProps> = ({
  range,
  toggleDay,
  updateFrom,
  updateTo,
  removeRange,
  onSave,
}) => {
  const [edit, setedit] = useState(false)

  const intToDate = (val: number) => {
    let result = ''

    if (val - (val % 1) < 10) {
      result += '0'
    }
    result += val - (val % 1)
    result += ':'

    if ((val % 1) * 60 < 10) {
      result += '0'
    }
    result += Math.floor((val % 1) * 60.0)
    return result.substr(0, 5)
  }

  const dateToInt = (val: string) : number => {
    let temp = val.substr(0, 2)
    if(temp[0] === '0') temp = temp.substr(1,1)
    
    return parseInt(temp)
  }

  if (!edit) {
    return (
      <div className="range">
        <div className="range_top">
          <span className="days_overview">
            <i className="fa fa-calendar" style={{ marginRight: '10px' }} />
            {range.days.includes(0) ? 'Mo ' : ''}
            {range.days.includes(1) ? 'Tu ' : ''}
            {range.days.includes(2) ? 'We ' : ''}
            {range.days.includes(3) ? 'Th ' : ''}
            {range.days.includes(4) ? 'Fr ' : ''}
            {range.days.includes(5) ? 'Sa ' : ''}
            {range.days.includes(6) ? 'Su ' : ''}
          </span>
          <br />
          <span className="fromto_overview">
            <i className="fa fa-clock-o" style={{ marginRight: '10px' }} />
            <span>{intToDate(convertHourToLocalTime(range.from))}</span>
            {' to '}
            <span>{intToDate(convertHourToLocalTime(range.to))}</span>
          </span>
        </div>
        <div className="range_bottom">
          <button
            className="edit"
            onClick={() => {
              setedit(true)
            }}
          >
            Edit
          </button>
        </div>
      </div>
    )
  }

  return (
    <div className="range">
      <div className="range_top">
        <div className="days">
          <span
            className={range.days.includes(0) ? 'day selected' : 'day'}
            onClick={() => {
              toggleDay(0)
            }}
            role="presentation"
          >
            M
          </span>
          <span
            className={range.days.includes(1) ? 'day selected' : 'day'}
            onClick={() => {
              toggleDay(1)
            }}
            role="presentation"
          >
            T
          </span>
          <span
            className={range.days.includes(2) ? 'day selected' : 'day'}
            onClick={() => {
              toggleDay(2)
            }}
            role="presentation"
          >
            W
          </span>
          <span
            className={range.days.includes(3) ? 'day selected' : 'day'}
            onClick={() => {
              toggleDay(3)
            }}
            role="presentation"
          >
            T
          </span>
          <span
            className={range.days.includes(4) ? 'day selected' : 'day'}
            onClick={() => {
              toggleDay(4)
            }}
            role="presentation"
          >
            F
          </span>
          <span
            className={range.days.includes(5) ? 'day selected' : 'day'}
            onClick={() => {
              toggleDay(5)
            }}
            role="presentation"
          >
            S
          </span>
          <span
            className={range.days.includes(6) ? 'day selected' : 'day'}
            onClick={() => {
              toggleDay(6)
            }}
            role="presentation"
          >
            S
          </span>
        </div>
        <div className="fromto columns">
          <div className="from column is-6">
            <label htmlFor="from">From</label>
            <br />
            <input
              name="from"
              type="time"
              value={intToDate(convertHourToLocalTime((range.from)))}
              onChange={(e) => updateFrom(dateToInt(e.target.value))}
            />
          </div>
          <div className="to column is-6">
            <label htmlFor="to">To</label>
            <br />
            <input
              name="to"
              type="time"
              value={intToDate(convertHourToLocalTime(range.to))}
              onChange={(e) => updateTo(dateToInt(e.target.value))}
            />
          </div>
        </div>
      </div>
      <div className="range_bottom">
        <button
          className="remove"
          onClick={() => {
            removeRange()
            setedit(false)
          }}
        >
          Remove
        </button>
        <button
          className="save"
          onClick={() => {
            onSave()
            setedit(false)
          }}
        >
          Save
        </button>
      </div>
    </div>
  )
}

export default Range
